import { Program, Provider } from '@coral-xyz/anchor';
import { IDL_V6, Jupiter } from './idl/jupiter6';
import { JUPITER_PROGRAM_V6_ID } from './constants';

export const JUPITER_PROGRAM = new Program<Jupiter>(IDL_V6, JUPITER_PROGRAM_V6_ID, {} as Provider);
